/**
 * @generated SignedSource<<6854da174648523510d92b721848b179>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLinkingDataContent$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
      readonly urlAlias: string;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersFilterSection">;
    } | null> | null;
  } | null> | null;
  readonly urlAlias: string;
  readonly " $fragmentType": "articleLinkingDataContent";
};
export type articleLinkingDataContent$key = {
  readonly " $data"?: articleLinkingDataContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLinkingDataContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLinkingDataContent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersFilterSection",
              "selections": [
                (v1/*: any*/)
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "entityLink"
            },
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "16b1002c1b07d910e3e953f7ea8ece0d";

export default node;
